module.exports = __webpack_public_path__ + "media/logos/logo_otomoto2-4455d9dc.png";